import { render, staticRenderFns } from "./PressureChart.vue?vue&type=template&id=2543b484&scoped=true&"
import script from "./PressureChart.vue?vue&type=script&lang=js&"
export * from "./PressureChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2543b484",
  null
  
)

export default component.exports